import { apiSlice } from "../../Api/apiSlice";

const quizApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get all quiz from videoId record
    getQuizWithVideoId: builder.query({
      query: (vid) => `/quizzes?video_id_like=${vid}`,
    }),
  }),
});
export const { useGetQuizWithVideoIdQuery } = quizApi;
